import rhinoSession from 'rhino/src/components/session/session.module';

import coreModule from 'rhino/src/core/core.module';
import * as rnDevice from './device.service';
import * as rnDcs from './dcs.service';
import * as systemStatisticsService from './system-statistics.service';
import * as rnInstructionsService from './instructions.service';
import * as rnDeviceDetector from './detector.service';
import rnSession from 'rhino/src/components/session/session.module';
import rnPusher from 'rhino/src/components/pusher/pusher.module';

export default angular.module('rhino.components.device', [coreModule, rhinoSession, rnSession, rnPusher])
  .factory(rnDevice.name, rnDevice.default)
  .factory(rnDcs.name, rnDcs.default)
  .factory(systemStatisticsService.name, systemStatisticsService.default)
  .factory(rnInstructionsService.name, rnInstructionsService.default)
  .factory(rnDeviceDetector.name, rnDeviceDetector.default)
  .name;
